import { render, staticRenderFns } from "./IrrigationManage.vue?vue&type=template&id=a1a98684&scoped=true&"
import script from "./IrrigationManage.vue?vue&type=script&lang=ts&"
export * from "./IrrigationManage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a98684",
  null
  
)

export default component.exports